const SUI_ADDRESS_REGEX = /^0x[0-9a-fA-F]{64}$/

function isValidSuiAddress(address) {
    return SUI_ADDRESS_REGEX.test(address)
}

export default {
    isValidAddress: isValidSuiAddress,
}
